/* eslint-disable react/jsx-props-no-spreading */
import {Redirect, Route, useLocation} from 'react-router-dom';
import React from 'react'
import {Status} from '../../common/const/const';
import routes from '../../common/routes/routes';


const PrivateRouter = ({component: Component, status, componentProps, ...restProps}) => {
    const location = useLocation();

    const authorizedRoutes = [routes.MAIN, routes.USERS];

    const getRoute = () => {
        if (status === Status.UN_AUTHORIZED) {
            if (location.pathname === routes.LOGIN) {
                return <Component {...componentProps} />
            }
            return <Redirect to={{pathname: routes.LOGIN, state: {from: location}}} />
        }
        if (status === Status.AUTHORIZED) {
            if (authorizedRoutes.indexOf(location.pathname) !== -1) {
                return <Component {...componentProps} />
            }
            return <Redirect to={{pathname: routes.MAIN, state: {from: location}}} />
        }

        return <Component {...componentProps} />
    }
    return (
        <Route {...restProps}>
            {getRoute()}
        </Route>
    )
}

export default PrivateRouter;
